/**
 * @author        tae@zumper.com (Tae Yoon)
 * @copyright     Copyright (c) 2019, Zumper
 * @description   Multi MessagingModal actions
 */

import type { InactiveSaveSearchModal } from '@zcode/state-type'
import { createAction } from 'redux-actions'
import { CLEAR_DATA, RECEIVE_DATA } from '../constants/inactiveSaveSearchModal'

export const receiveInactiveSaveSearchData = createAction<
  InactiveSaveSearchModal,
  typeof RECEIVE_DATA
>(RECEIVE_DATA)
export const clearInactiveSaveSearchData = createAction(CLEAR_DATA)
